import { useState } from "react";
import { Transition } from "@headlessui/react";
import { motion } from "framer-motion";
import { Image, MoveRight } from "lucide-react";

export default function Card({
    title,
    ingredients,
    price,
    image,
    quantity,
    alcoholPercentage,
    type,
    isAvailable,
    showDetailPage,
    isNew,
    onClick,
}) {
    const [loaded, setLoaded] = useState(false);

    return (
        <Transition
            appear
            show={true}
            enter="transition ease-out duration-300"
            enterFrom="opacity-0 translate-y-3"
            enterTo="opacity-100 translate-y-0"
        >
            <motion.div
                whileTap={showDetailPage && isAvailable ? { scale: 0.98 } : {}}
                onClick={() => showDetailPage && isAvailable && onClick?.()}
                className={`w-full group ${showDetailPage && isAvailable ? "cursor-pointer" : "cursor-default"}`}
            >
                <div className={`relative bg-[#121824]/60 backdrop-blur-sm border rounded-2xl p-4 flex gap-4 items-start transition-all duration-300 overflow-hidden ${
                    !isAvailable 
                        ? "opacity-40 grayscale border-accent/10" 
                        : showDetailPage 
                            ? "border-accent/30 hover:border-primary/40 hover:bg-[#1A2234]/50 shadow-lg shadow-black/10" 
                            : "border-accent/20"
                } pb-4`}> {/* Spazio inferiore extra se c'è il tasto dettaglio */}
                    
                    {/* Badge NEW minimalista */}
                    {isNew && isAvailable && (
                        <div className="absolute top-0 left-0 bg-primary text-black text-[9px] font-black uppercase px-2.5 py-0.5 rounded-br-xl shadow-md z-10 tracking-widest">
                            New
                        </div>
                    )}

                    {/* 🔘 Contenitore Immagine Circolare Premium */}
                    <div className="relative w-20 h-20 sm:w-24 sm:h-24 rounded-full border-2 border-accent/30 bg-[#090D16] shadow-[0_0_15px_rgba(233,69,69,0.05)] overflow-hidden shrink-0 mt-1">
                        {/* Skeleton Loader */}
                        {!loaded && image && (
                            <div className="absolute inset-0 bg-[#1A2234] animate-pulse rounded-full" />
                        )}

                        {image ? (
                            <img
                                src={image}
                                alt={title}
                                crossOrigin="anonymous"
                                onLoad={() => setLoaded(true)}
                                className={`w-full h-full object-cover rounded-full transition-all duration-500 group-hover:scale-105 ${
                                    loaded ? "opacity-100" : "opacity-0"
                                }`}
                            />
                        ) : (
                            <div className="w-full h-full flex flex-col items-center justify-center text-muted/40 bg-background/50 rounded-full">
                                <Image className="w-5 h-5 stroke-[1.5]" />
                                <span className="text-[8px] mt-0.5 tracking-wider uppercase">No foto</span>
                            </div>
                        )}
                    </div>

                    {/* 📝 Corpo Informativo */}
                    <div className="flex-1 flex flex-col justify-start min-w-0">
                        {/* Titolo */}
                        <h3 className="text-secondary font-bold text-base sm:text-lg leading-tight tracking-tight group-hover:text-primary transition-colors duration-200 break-words">
                            {title}
                        </h3>

                        {/* Ingredienti (Senza limiti di righe, si espande sempre) */}
                        {ingredients && (
                            <p className="text-xs text-muted/80 leading-relaxed mt-1 break-words whitespace-normal">
                                {ingredients}
                            </p>
                        )}

                        {/* Info Drink / Specifiche */}
                        {type === "drink" && (quantity || alcoholPercentage) && (
                            <div className="text-[10px] text-primary/70 font-semibold tracking-wider uppercase mt-1.5 flex gap-3 items-center">
                                {quantity && <span>{quantity}</span>}
                                {quantity && alcoholPercentage && <span className="w-1 h-1 bg-accent/40 rounded-full" />}
                                {alcoholPercentage && <span>Vol. {alcoholPercentage}</span>}
                            </div>
                        )}

                        {/* Prezzo o Stato Disponibilità */}
                        <div className="mt-2.5 flex items-center">
                            {isAvailable ? (
                                <span className="text-base font-black tracking-tight text-primary">
                                    {price}
                                </span>
                            ) : (
                                <span className="text-[10px] uppercase font-bold tracking-wider text-muted bg-accent/20 px-2 py-0.5 rounded-md border border-accent/10">
                                    Non disponibile
                                </span>
                            )}
                        </div>
                    </div>

                    {/* 🔗 Freccia di Dettaglio in Basso a Destra (In asola floating isolata) */}
                    {showDetailPage && isAvailable && (
                        <div className="absolute bottom-0 right-0 bg-[#090D16] border-tl border-l border-t border-accent/30 pl-3 pt-3 pb-3 pr-3 rounded-tl-2xl flex items-center justify-center text-muted group-hover:text-primary group-hover:border-primary/40 transition-all duration-300 shadow-lg">
                            <MoveRight className="w-4 h-4 stroke-[2.5] group-hover:translate-x-0.5 transition-transform duration-200" />
                        </div>
                    )}
                </div>
            </motion.div>
        </Transition>
    );
}